import React, { useState, useEffect } from 'react';
import { getEaListInit, searchEaList, updateEaStatus } from '../api/api';

function EaList() {
  const [eaList, setEaList] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [eanames, setEanames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 20;

  // 검색 조건
  const [search, setSearch] = useState({
    login: '',
    broker: '',
    eaname: '',
    dbsts: '',
    metatype: '',
    accounttype: '',
    page: 1,
    size: 20
  });

  // 선택된 항목
  const [selected, setSelected] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // 모달
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ dbsts: 'A', startdate: '', enddate: '' });

  useEffect(() => {
    fetchInit();
  }, []);

  const fetchInit = async () => {
    try {
      const res = await getEaListInit();
      setBrokers(res.data.brokerList || []);
      setEanames(res.data.eanameList || []);
      // 초기 검색 실행
      handleSearch(1);
    } catch (err) {
      console.error('Init error:', err);
      setLoading(false);
    }
  };

  const handleSearch = async (page = 1) => {
    setLoading(true);
    try {
      const res = await searchEaList({ ...search, page, size: pageSize });
      setEaList(res.data.list || []);
      setTotalCount(res.data.total || 0);
      setCurrentPage(res.data.page || 1);
      setTotalPages(Math.ceil((res.data.total || 0) / pageSize));
    } catch (err) {
      console.error('Search error:', err);
    }
    setLoading(false);
    setSelected([]);
    setSelectAll(false);
  };

  const handleReset = () => {
    setSearch({
      login: '',
      broker: '',
      eaname: '',
      dbsts: '',
      metatype: '',
      accounttype: '',
      page: 1,
      size: 20
    });
    setTimeout(() => handleSearch(1), 100);
  };

  const handleSelectAll = (e) => {
    setSelectAll(e.target.checked);
    if (e.target.checked) {
      setSelected(eaList.map(ea => ea.eacheckseq));
    } else {
      setSelected([]);
    }
  };

  const handleSelect = (eacheckseq) => {
    if (selected.includes(eacheckseq)) {
      setSelected(selected.filter(id => id !== eacheckseq));
    } else {
      setSelected([...selected, eacheckseq]);
    }
  };

  const handleBatchUpdate = async () => {
    if (selected.length === 0) {
      alert('수정할 EA를 선택해주세요.');
      return;
    }

    try {
      // 선택된 항목들을 하나씩 업데이트
      for (const eacheckseq of selected) {
        await updateEaStatus({
          eacheckseq: eacheckseq,
          dbsts: modalData.dbsts,
          startdate: modalData.startdate || null,
          enddate: modalData.enddate || null
        });
      }
      
      alert(`${selected.length}개 EA가 업데이트되었습니다.`);
      setShowModal(false);
      handleSearch(currentPage);
    } catch (err) {
      alert('오류가 발생했습니다.');
      console.error(err);
    }
  };

  const getStatusBadge = (dbsts, enddate) => {
    if (dbsts === 'Pending') return <span className="badge badge-pending">대기중</span>;
    if (dbsts === 'D') return <span className="badge badge-denied">거부</span>;
    if (dbsts === 'A') {
      if (enddate) {
        const daysLeft = Math.ceil((new Date(enddate) - new Date()) / (1000 * 60 * 60 * 24));
        if (daysLeft < 0) return <span className="badge badge-expired">만료</span>;
        if (daysLeft <= 10) return <span className="badge badge-pending">만료임박</span>;
      }
      return <span className="badge badge-active">활성</span>;
    }
    return <span className="badge">{dbsts}</span>;
  };

  const getDaysLeft = (enddate) => {
    if (!enddate) return null;
    return Math.ceil((new Date(enddate) - new Date()) / (1000 * 60 * 60 * 24));
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined) return '0';
    return Number(num).toLocaleString();
  };

  return (
    <div>
      {/* Filter Bar */}
      <div className="table-container" style={{ marginBottom: '24px' }}>
        <div className="filters-bar">
          <div className="filter-item">
            <label>Login</label>
            <input
              type="text"
              placeholder="계좌번호"
              value={search.login}
              onChange={(e) => setSearch({ ...search, login: e.target.value })}
            />
          </div>

          <div className="filter-item">
            <label>Broker</label>
            <select
              value={search.broker}
              onChange={(e) => setSearch({ ...search, broker: e.target.value })}
            >
              <option value="">전체</option>
              {brokers.map(b => <option key={b} value={b}>{b}</option>)}
            </select>
          </div>

          <div className="filter-item">
            <label>EA명</label>
            <select
              value={search.eaname}
              onChange={(e) => setSearch({ ...search, eaname: e.target.value })}
            >
              <option value="">전체</option>
              {eanames.map(e => <option key={e} value={e}>{e}</option>)}
            </select>
          </div>

          <div className="filter-item">
            <label>상태</label>
            <select
              value={search.dbsts}
              onChange={(e) => setSearch({ ...search, dbsts: e.target.value })}
            >
              <option value="">전체</option>
              <option value="A">활성 (A)</option>
              <option value="Pending">대기중</option>
              <option value="D">거부 (D)</option>
            </select>
          </div>

          <div className="filter-item">
            <label>Meta Type</label>
            <select
              value={search.metatype}
              onChange={(e) => setSearch({ ...search, metatype: e.target.value })}
            >
              <option value="">전체</option>
              <option value="MT4">MT4</option>
              <option value="MT5">MT5</option>
            </select>
          </div>

          <div className="filter-item">
            <label>계좌 유형</label>
            <select
              value={search.accounttype}
              onChange={(e) => setSearch({ ...search, accounttype: e.target.value })}
            >
              <option value="">전체</option>
              <option value="Demo">Demo</option>
              <option value="Real">Real</option>
            </select>
          </div>

          <div className="filter-buttons">
            <button className="btn btn-primary" onClick={() => handleSearch(1)}>
              🔍 검색
            </button>
            <button className="btn btn-secondary" onClick={handleReset}>
              초기화
            </button>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="table-container">
        <div className="table-header">
          <h2>
            📋 EA 목록 ({totalCount}건)
            <button 
              className="btn btn-secondary btn-sm"
              style={{ marginLeft: '12px' }}
              onClick={() => handleSearch(currentPage)}
            >
              ↻ 새로고침
            </button>
          </h2>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button 
              className="btn btn-success btn-sm"
              onClick={() => {
                if (selected.length === 0) {
                  alert('수정할 EA를 선택해주세요.');
                  return;
                }
                setModalData({ dbsts: 'A', startdate: '', enddate: '' });
                setShowModal(true);
              }}
            >
              ✅ 승인
            </button>
            <button 
              className="btn btn-danger btn-sm"
              onClick={() => {
                if (selected.length === 0) {
                  alert('수정할 EA를 선택해주세요.');
                  return;
                }
                setModalData({ dbsts: 'D', startdate: '', enddate: '' });
                setShowModal(true);
              }}
            >
              ❌ 거부
            </button>
          </div>
        </div>

        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th style={{ width: '40px' }}>
                      <input
                        type="checkbox"
                        className="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th>상태</th>
                    <th>EA명</th>
                    <th>Login</th>
                    <th>Broker</th>
                    <th>Trader</th>
                    <th>Type</th>
                    <th>계좌</th>
                    <th>Balance</th>
                    <th>만료일</th>
                    <th>D-Day</th>
                    <th>마지막 접속</th>
                  </tr>
                </thead>
                <tbody>
                  {eaList.length === 0 ? (
                    <tr>
                      <td colSpan="12" style={{ textAlign: 'center', padding: '40px' }}>
                        검색 결과가 없습니다.
                      </td>
                    </tr>
                  ) : (
                    eaList.map((ea) => {
                      const daysLeft = getDaysLeft(ea.enddate);
                      return (
                        <tr key={ea.eacheckseq}>
                          <td>
                            <input
                              type="checkbox"
                              className="checkbox"
                              checked={selected.includes(ea.eacheckseq)}
                              onChange={() => handleSelect(ea.eacheckseq)}
                            />
                          </td>
                          <td>{getStatusBadge(ea.dbsts, ea.enddate)}</td>
                          <td><strong>{ea.eaname}</strong></td>
                          <td>{ea.login}</td>
                          <td style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {ea.broker}
                          </td>
                          <td>{ea.tradername || '-'}</td>
                          <td>{ea.metatype || '-'}</td>
                          <td>{ea.accounttype || '-'}</td>
                          <td>${formatNumber(ea.balance)}</td>
                          <td>{ea.enddate?.substring(0, 10) || '-'}</td>
                          <td style={{ 
                            fontWeight: 600,
                            color: daysLeft === null ? '#94A3B8' : daysLeft < 0 ? '#EF4444' : daysLeft <= 10 ? '#F59E0B' : '#10B981'
                          }}>
                            {daysLeft !== null ? (daysLeft < 0 ? `${daysLeft}일` : `D-${daysLeft}`) : '-'}
                          </td>
                          <td>{ea.lastaccessdate?.substring(0, 16) || '-'}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="pagination">
                <button
                  onClick={() => handleSearch(1)}
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
                <button
                  onClick={() => handleSearch(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </button>
                
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  let page;
                  if (totalPages <= 5) {
                    page = i + 1;
                  } else if (currentPage <= 3) {
                    page = i + 1;
                  } else if (currentPage >= totalPages - 2) {
                    page = totalPages - 4 + i;
                  } else {
                    page = currentPage - 2 + i;
                  }
                  return (
                    <button
                      key={page}
                      className={currentPage === page ? 'active' : ''}
                      onClick={() => handleSearch(page)}
                    >
                      {page}
                    </button>
                  );
                })}

                <button
                  onClick={() => handleSearch(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  &gt;
                </button>
                <button
                  onClick={() => handleSearch(totalPages)}
                  disabled={currentPage === totalPages}
                >
                  &raquo;
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>EA 상태 변경</h3>
              <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
            </div>

            <p style={{ marginBottom: '20px', color: '#64748B' }}>
              선택된 {selected.length}개 EA의 상태를 변경합니다.
            </p>

            <div className="form-group">
              <label className="form-label">상태</label>
              <select
                className="form-select"
                value={modalData.dbsts}
                onChange={(e) => setModalData({ ...modalData, dbsts: e.target.value })}
              >
                <option value="A">활성 (A)</option>
                <option value="Pending">대기중</option>
                <option value="D">거부 (D)</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">시작일</label>
              <input
                type="date"
                className="form-input"
                value={modalData.startdate}
                onChange={(e) => setModalData({ ...modalData, startdate: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label className="form-label">만료일</label>
              <input
                type="date"
                className="form-input"
                value={modalData.enddate}
                onChange={(e) => setModalData({ ...modalData, enddate: e.target.value })}
              />
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                취소
              </button>
              <button className="btn btn-primary" onClick={handleBatchUpdate}>
                저장
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EaList;